
const formdata = [
  {
    inputdata: "",
    title: "发票号",
    fontSize: "14px",
    color: "#333333",
    placeholder: "请输入",
    types: "text",
    inputtype: "input",
    width: "210px",
  },
  {
    inputdata: "",
    title: "开票日期",
    fontSize: "14px",
    color: "#333333",
    placeholder: "",
    types: "",
    inputtype: "dates",
    width: "180px",
    widths: "210px",
    lablewith: "105px"
  },
  {
    inputdata: "",
    title: "发票类型",
    fontSize: "14px",
    color: "#333333",
    placeholder: "全部",
    types: "",
    lablewith: "109px",
    inputtype: "select",
    width: "220px",
    lablewith: "125px",
    // options: []
  },
  {
    inputdata: "",
    title: "发票校验码",
    fontSize: "14px",
    color: "#333333",
    placeholder: "请输入",
    types: "text",
    inputtype: "input",
    width: "220px",
    lablewith: "125px",
  },
  {
    inputdata: "",
    title: "发票代码",
    fontSize: "14px",
    color: "#333333",
    placeholder: "请输入",
    types: "text",
    inputtype: "input",
    width: "210px",
    lablewith: "80px"
  },
  {
    inputdata: "1",
    title: "发票无税金额",
    fontSize: "14px",
    color: "#333333",
    placeholder: "",
    types: "",
    inputtype: "numberPX",
    width: "160px",
    min: -999999999,
    max: 999999999,
    width: "210px",
    widths: "210px",
    lablewith: "105px"
  },
  // {
  //   inputdata: "",
  //   title: "输出参数",
  //   fontSize: "14px",
  //   // lablewith: '109px',
  //   color: "#333333",
  //   placeholder: "",
  //   types: "",
  //   inputtype: "textarea",
  //   width: "855px",
  //   height: "400px",
  //   min: "1",
  //   max: "1000",
  // },
];
export default formdata;
